import axios from 'axios'
import i18n from '@/plugins/i18n'

// Модель для работы с охотниками
export default {
  // Получение списка
  getList (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/oopt_hunter/getList?${filter}`)
  },
  // Получение данных для формы поиска
  getSearchFormData () {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getSearchFormData`)
  },
  // Получение данных для формы
  getFormData () {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getFormData`)
  },
  // Получение данных
  getInfo (id) {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getInfo/${id}`)
  },
  // Создание
  create (data) {
    return axios.post(`${i18n.locale}/api/oopt_hunter/create`, data)
  },
  // Редактирование
  update (id, data) {
    return axios.post(`${i18n.locale}/api/oopt_hunter/edit/${id}`, data)
  },
  // Получение данных для формы удостоверения
  getTicketFormData () {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getTicketFormData`)
  },
  // Получение данных для отображения удостоверения
  showTicket (id) {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getTicketInfo/${id}`)
  },
  // Создание/обновление удостоверения
  updateTicket (params, data) {
    return axios.post(`${i18n.locale}/api/oopt_hunter/${params.route}/${params.id}`, data)
  },
  // Удаление сущности удостоверения
  deleteTicket (id) {
    return axios.delete(`${i18n.locale}/api/oopt_hunter/deleteTicket/${id}`)
  },
  // Получение данных для отображения аттестации
  showCertification (id) {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getCertificationInfo/${id}`)
  },
  // Создание/обновление аттестации
  updateCertification (params, data) {
    return axios.post(`${i18n.locale}/api/oopt_hunter/${params.route}/${params.id}`, data)
  },
  // Удаление сущности аттестации
  deleteCertification (id) {
    return axios.delete(`${i18n.locale}/api/oopt_hunter/deleteCertification/${id}`)
  },
  // Получение списка
  checkUniqueHunter (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/oopt_hunter/checkUniqueHunter?${filter}`)
  },
  // Получение списка по ФИО или ПИН
  getListByFioOrPin (type, fioPin) {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getListByFioOrPin/${type}?fioPin=${fioPin}`)
  },
  // Получение данных для формы животных
  getAnimalFormData () {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getOoptHunterAnimalFormData`)
  },
  // Получение данных для отображения животных
  showAnimal (id) {
    return axios.get(`${i18n.locale}/api/oopt_hunter/getOoptHunterAnimalInfo/${id}`)
  },
  // Создание/обновление животных
  updateAnimal (params, data) {
    return axios.post(`${i18n.locale}/api/oopt_hunter/${params.route}/${params.id}`, data)
  },
  // Удаление сущности животных
  deleteAnimal (id) {
    return axios.delete(`${i18n.locale}/api/oopt_hunter/deleteOoptHunterAnimal/${id}`)
  }
}
